// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IInvestmentCashHoldingDetailsDto } from './IInvestmentCashHoldingDetailsDto';
import {
    instanceOfIInvestmentCashHoldingDetailsDto,
    IInvestmentCashHoldingDetailsDtoFromJSON,
    IInvestmentCashHoldingDetailsDtoFromJSONTyped,
    IInvestmentCashHoldingDetailsDtoToJSON,
} from './IInvestmentCashHoldingDetailsDto';
import type { IInvestmentFundHoldingDetailsDto } from './IInvestmentFundHoldingDetailsDto';
import {
    instanceOfIInvestmentFundHoldingDetailsDto,
    IInvestmentFundHoldingDetailsDtoFromJSON,
    IInvestmentFundHoldingDetailsDtoFromJSONTyped,
    IInvestmentFundHoldingDetailsDtoToJSON,
} from './IInvestmentFundHoldingDetailsDto';

/**
 * @type IInvestmentDetailsDtoHoldingsInner
 * 
 * @export
 */
export type IInvestmentDetailsDtoHoldingsInner = IInvestmentCashHoldingDetailsDto | IInvestmentFundHoldingDetailsDto;

export function IInvestmentDetailsDtoHoldingsInnerFromJSON(json: any): IInvestmentDetailsDtoHoldingsInner {
    return IInvestmentDetailsDtoHoldingsInnerFromJSONTyped(json, false);
}

export function IInvestmentDetailsDtoHoldingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentDetailsDtoHoldingsInner {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIInvestmentCashHoldingDetailsDto(json)) {
        return IInvestmentCashHoldingDetailsDtoFromJSONTyped(json, true);
    }
    if (instanceOfIInvestmentFundHoldingDetailsDto(json)) {
        return IInvestmentFundHoldingDetailsDtoFromJSONTyped(json, true);
    }

    return {} as any;
}

export function IInvestmentDetailsDtoHoldingsInnerToJSON(json: any): any {
    return IInvestmentDetailsDtoHoldingsInnerToJSONTyped(json, false);
}

export function IInvestmentDetailsDtoHoldingsInnerToJSONTyped(value?: IInvestmentDetailsDtoHoldingsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIInvestmentCashHoldingDetailsDto(value)) {
        return IInvestmentCashHoldingDetailsDtoToJSON(value as IInvestmentCashHoldingDetailsDto);
    }
    if (instanceOfIInvestmentFundHoldingDetailsDto(value)) {
        return IInvestmentFundHoldingDetailsDtoToJSON(value as IInvestmentFundHoldingDetailsDto);
    }

    return {};
}

